import { render, staticRenderFns } from "./WealthStatement.vue?vue&type=template&id=060cc73c&scoped=true&"
import script from "./WealthStatement.vue?vue&type=script&lang=ts&"
export * from "./WealthStatement.vue?vue&type=script&lang=ts&"
import style0 from "./WealthStatement.vue?vue&type=style&index=0&id=060cc73c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060cc73c",
  null
  
)

export default component.exports